module.exports = __webpack_public_path__ + "img/image19.82621a77.png";